/* Maison Septième: collection filtering, sorting and view toggle (no dependencies) */
(() => {
  'use strict';
  const root = document.querySelector('[data-collection]');
  if (!root) return;
  const sectionId = root.dataset.sectionId;
  const form = root.querySelector('[data-facets-form]');
  const sort = root.querySelector('[data-sort]');
  const VIEW_KEY = 'ms-collection-view';
  let controller = null;
  let debounce;

  const setView = (view) => {
    root.classList.toggle('is-room', view === 'room');
    root.querySelectorAll('[data-view]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.view === view)));
    try { localStorage.setItem(VIEW_KEY, view); } catch (e) { /* storage unavailable */ }
  };
  root.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-view]');
    if (btn) setView(btn.dataset.view);
  });
  try { const saved = localStorage.getItem(VIEW_KEY); if (saved) setView(saved); } catch (e) { /* ignore */ }

  const buildQuery = () => {
    const params = new URLSearchParams();
    if (form) {
      new FormData(form).forEach((value, key) => { if (String(value).trim() !== '') params.append(key, value); });
    }
    if (sort && !params.has('sort_by')) params.set('sort_by', sort.value);
    return params.toString();
  };

  const render = async (url, push = true) => {
    if (controller) controller.abort();
    controller = new AbortController();
    root.classList.add('is-loading');
    const fetchUrl = new URL(url, window.location.origin);
    fetchUrl.searchParams.set('section_id', sectionId);
    try {
      const res = await fetch(fetchUrl.toString(), { signal: controller.signal });
      const html = await res.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const swap = (sel) => {
        const next = doc.querySelector(sel);
        const current = root.querySelector(sel);
        if (next && current) current.replaceWith(next);
      };
      swap('[data-collection-results]');
      swap('[data-facets-inner]');
      ['[data-product-count]', '[data-product-count-short]'].forEach((sel) => {
        const next = doc.querySelector(sel); const current = root.querySelector(sel);
        if (next && current) current.textContent = next.textContent;
      });
      const nextBadge = doc.querySelector('[data-active-count]');
      const badge = root.querySelector('[data-active-count]');
      if (nextBadge && badge) { badge.textContent = nextBadge.textContent; badge.hidden = nextBadge.hidden; }
      if (push) {
        const clean = new URL(url, window.location.origin);
        clean.searchParams.delete('section_id');
        window.history.replaceState({}, '', clean.pathname + clean.search);
      }
      const results = root.querySelector('[data-collection-results]');
      if (window.msInit && results) window.msInit(results);
      if (results) results.querySelectorAll('[data-reveal]').forEach((el) => el.classList.add('is-visible'));
    } catch (err) {
      if (err.name !== 'AbortError') window.location.href = url;
    } finally {
      root.classList.remove('is-loading');
    }
  };

  const update = () => {
    const query = buildQuery();
    render(`${window.location.pathname}${query ? `?${query}` : ''}`);
  };

  if (form) {
    form.addEventListener('change', (e) => {
      clearTimeout(debounce);
      debounce = setTimeout(update, e.target.type === 'number' ? 600 : 0);
    });
    form.addEventListener('input', (e) => {
      if (e.target.type !== 'number') return;
      clearTimeout(debounce);
      debounce = setTimeout(update, 800);
    });
    form.addEventListener('submit', (e) => { e.preventDefault(); update(); });
  }
  if (sort) sort.addEventListener('change', update);

  root.addEventListener('click', (e) => {
    const link = e.target.closest('[data-facet-link]');
    if (!link) return;
    e.preventDefault();
    render(link.getAttribute('href'));
  });
})();
